import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getEntityDetails } from "../../../api/entity";
import ChatHeader from "./ChatHeader";
import MessageList from "./MessageList";
import ChatInput from "./ChatInput";
import NoMessagesWindow from "./NoMessagesWindow";
import { Chat, EntityInfo, UserInfo } from "../../../types";

const ChatWindow = ({ chats }: { chats: Chat[] }) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { chatId, sendToID } = useParams<{
    chatId: string;
    sendToID: string;
  }>();
  const [sendToUser, setSendToUser] = useState<UserInfo | null>();
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!sendToID || !chatId) return;

    const getSendToUserData = async () => {
      try {
        const userData = await getEntityDetails(`${sendToID}`);
        setSendToUser(userData);
      } catch (error) {
        // console.error("Error fetching entity details:", error);
        setSendToUser(null);
      }
    };

    getSendToUserData();
  }, [sendToID, chatId]);

  if (!chatId) return <NoMessagesWindow />;

  if (!sendToUser) return <span>No user found</span>;

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <ChatHeader sendToUser={sendToUser} isActive={isActive} />
      <MessageList
        sendToUser={sendToUser}
        setIsActive={setIsActive}
        chats={chats}
        scrollContainerRef={scrollContainerRef}
      />
      <ChatInput scrollContainerRef={scrollContainerRef} />
    </Box>
  );
};

export default ChatWindow;
